import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateGiftOrderNames } from "../api";
import { giftOrdersKeys } from "../queries/keys";
import type {
  GiftOrdersListResponse,
  UpdateGiftOrderNamesPayload,
} from "../../types";

export const useUpdateGiftOrderNamesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpdateGiftOrderNamesPayload) => {
      const { data } = await updateGiftOrderNames(payload);
      return data;
    },
    onSuccess: (_data, variables) => {
      queryClient.setQueriesData<GiftOrdersListResponse>(
        { queryKey: giftOrdersKeys.all },
        (old) =>
          old
            ? {
                ...old,
                data: old.data.map((row) =>
                  row.orderItemId === variables.orderItemId
                    ? { ...row, ...variables }
                    : row,
                ),
              }
            : old,
      );
    },
  });
};
